import script from "./StoreAdminAnnouncements.vue?vue&type=script&setup=true&lang=js"
export * from "./StoreAdminAnnouncements.vue?vue&type=script&setup=true&lang=js"

import "./StoreAdminAnnouncements.vue?vue&type=style&index=0&id=7b83ce75&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b83ce75"]])

export default __exports__